import React from 'react'
import ReactEchartsCore from 'echarts-for-react/lib/core';
import echarts from 'echarts/lib/echarts';
import 'echarts/lib/chart/bar'
import 'echarts/lib/chart/line'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/legend'
import 'echarts/lib/chart/pie';
import 'echarts/lib/chart/scatter';
import 'echarts/lib/chart/bar';
import 'echarts/lib/chart/map';
import 'echarts/lib/chart/graph';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import 'echarts/lib/component/legend';
import 'echarts/lib/component/graphic';
import 'echarts/lib/component/visualMap';
import 'echarts/lib/component/dataZoom'


export const SaleLine = (props: any) => {

  const {
    xData = [],
    yData = [[], []],
  } = props

  const getOption = () => {
    return {
      title: {
        text: '营业额/应收金额'
      },
      tooltip: {
        trigger: 'axis'
      },
      legend: {
        data: ['营业额', '应收金额']
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '3%',
        containLabel: true
      },
      xAxis: {
        type: 'category',
        boundaryGap: false,
        data: xData,
        axisLabel:{
          interval:0,//横轴信息全部显示
          rotate:-20,// -20度角倾斜显示
      }
      },

      yAxis: {
        type: 'value'
      },
      series: [
        {
          name: '营业额',
          type: 'line',
          data: yData[0]
        },
        {
          name: '应收金额',
          type: 'line',
          data: yData[1]
        }
      ],
      dataZoom: [//给x轴设置滚动条
      {
        type: 'slider',//slider表示有滑动块的，inside表示内置的
        // startValue: 8,//可用于设置开始显示的柱子的长度
        // endValue: 1,//可用于设置结束显示的柱子的长度
        start: 0,//默认为0  可设置滚动条从在后进行展示
        end: 40,//默认为100
        show: true,
        xAxisIndex: [0],
        handleSize: 0,//滑动条的 左右2个滑动条的大小
        height: 12,//组件高度
        left: '5%', //左边的距离
        right: '5%',//右边的距离
        bottom: -2,//右边的距离
        borderColor: "#6767fa", //两边未选中的滑动条区域的颜色
        fillerColor: '#4d90ff',// 两边选中的滑动条区域的颜色
        backgroundColor: '#eee',//两边未选中的滑动条区域的颜色
        showDataShadow: false,//是否显示数据阴影 默认auto
        showDetail: false,//即拖拽时候是否显示详细数值信息 默认true
        realtime: true, //是否实时更新
        filterMode: 'filter',
        handleStyle: {
          borderRadius: '20',
        },
      },
      //下面这个属性是里面拖到
      {
        type: 'inside',
        show: true,
        xAxisIndex: [0], // 与上面xAxisIndex对应
        start: 0,//默认为1
        end: 100,//默认为100
        moveOnMouseWheel: false, // 鼠标滚轮时是否滚动
        preventDefaultMouseMove: false, // 是否阻止默认的鼠标移动事件
      },
    ],
    };
  }

  return (
    <ReactEchartsCore
      echarts={echarts}
      option={getOption() as echarts.EChartOption<echarts.EChartOption.Series>}
      style={{ height: '90%' }}
    />
  )
}